module.exports = __webpack_public_path__ + "img/map_1.041012ef.webp";